import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { QuestionPaperModal } from "./question-paper-modal";
import { SectionQuestionMappingEntity } from "../../ai-generated-qp/entities/section-question-mapping.entity";
import { ChapterWiseModel } from "./chapter-wise-model.entity";

@Entity("section_wise_model")
export class SectionWiseModel {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column("int", { name: "marks" })
    marks: number;

    @Column("text", { name: "note" })
    note: string;

    @Column("int", { name: "no_of_qns" })
    noOfQns: number;

    @Column("int", { name: "mandatory_qns" })
    mandatoryQns: number;

    @Column("int", { name: "each_qn_weightage" })
    eachQnWeightage: number;

    @Column("int", { name: "section_no" })
    sectionNo: number;

    @ManyToOne(() => QuestionPaperModal, (qnpModel) => qnpModel.sectionsWiseModel)
    @JoinColumn({ name: 'qnp_model' })
    qnpModel: QuestionPaperModal

    @OneToMany(() => SectionQuestionMappingEntity, (sections) => sections.section)
    sectionsQuestionMapping: SectionQuestionMappingEntity[];

    @OneToMany(() => ChapterWiseModel, (chapters) => chapters.sectionWiseModel, { cascade: true })
    chapterWiseModel: ChapterWiseModel[];
}
